<template>
  <v-card class="tab-card bg-dot-img"
  >
    <v-tabs
      v-model="tab"
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1" class="tabs-box" @click.prevent.stop="CheckTab('member')">
        Manage Members
      </v-tab>

      <v-tab href="#tab-2" class="tabs-box" @click.prevent.stop="CheckTab('friend')">
        Refer Friends
      </v-tab>

      <v-tab href="#tab-3" class="tabs-box" @click.prevent.stop="CheckTab('point')">
        Reward Points
      </v-tab>
      <v-tab href="#tab-4" class="tabs-box" @click.prevent.stop="CheckTab('plan')">
        My Plan
      </v-tab>
      <v-tab href="#tab-5" class="tabs-box" @click.prevent.stop="CheckTab('setting')">
        Notification Settings
      </v-tab>
      <v-tab href="#tab-6" class="tabs-box" @click.prevent.stop="CheckTab('datasecure')">
        Data Security
      </v-tab>
      <!-- <v-tab href="#tab-7" class="tabs-box" @click.prevent.stop="CheckTab('privacypolicy')">
        Privacy Policy
      </v-tab> -->
       <v-tab href="#tab-8" class="tabs-box" @click.prevent.stop="CheckTab('accountmanage')">
        Account Management
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="tabs-content">
      <v-tab-item
        value="tab-1"
        v-if="tabName=='member'"
      >
          <Membership v-if="tabName=='member'" />
          
      </v-tab-item>
      <v-tab-item
        value="tab-2"
        v-if="tabName=='friend'"
      >
        <!-- <v-card flat>
          <v-card-text> text 1</v-card-text>
        </v-card> -->
        <ReferFriends v-if="tabName=='friend'"/>
      </v-tab-item>

      <v-tab-item
        value="tab-3"
        v-if="tabName=='point'"
      >
       <!--  <v-card flat>
          <v-card-text> text 2</v-card-text>
        </v-card> -->
        <RewardsPoint v-if="tabName=='point'"/>
      </v-tab-item>

      <v-tab-item
        class="myplan-box"
        value="tab-4"
        v-if="tabName=='plan'"
      >
       <!--  <v-card flat> -->
          <!-- <v-card-text> MY PLAN </v-card-text>
        </v-card> -->
        <Myplan v-if="tabName=='plan'"/>
      </v-tab-item>

      <v-tab-item
        value="tab-5"
        v-if="tabName=='setting'"
      >
        <NotificationSetting flat v-if="tabName=='setting'"/>

      </v-tab-item>
      <v-tab-item
        value="tab-6"
        v-if="tabName=='datasecure'"
      >
         <v-card class="secure-modal">
            <v-card-title class="text-h5  ">
              Nimeya is Secure & Private
            </v-card-title>
            <v-card-text>
             <ul style="margin-top:10px;">
              <span><b>With Nimeya, your information is secure and private.</b></span>

              <li>We are hosted securely on Amazon’s AWS Cloud</li>
              <li>Information is stored in an end-to-end encrypted form and is SSL secured</li>
              <li>Data is protected using 128/256-bit encryption technology</li>
              <li>2 factor authentication using mobile and email or biometric based access to app</li>
              <li>No data sharing with any third party</li>
              <li>Strong privacy policy</li>
              <li>General Data Protection Regulation (GDPR) compliant</li>
            </ul>
            </v-card-text>
           
          </v-card>
      </v-tab-item>
       <v-tab-item
        value="tab-7"
        v-if="tabName=='privacypolicy'"
      >
         <v-card class="secure-modal">
            <v-card-text>
             <ul style="margin-top:10px;">
              <span><b>What Personal Information About Members / Subscribers Does Nimeya Collect?</b></span>
              <span> <p>We collect the personal information to know who you are and the following are kept for our future references. This further helps to self-authenticate you during accessing our application and to give you the access to your secured personal data.</p> </span>
              <span><p>Here are few types of personal information we collect:</p></span>
              <li><b>Full Name as appears in your PAN / Aadhar Card:</b> This identifies you.</li>
              <li><b>Date of Birth:</b>  This provides your DOB as appeared in your PAN/Aadhar Card </li>
              <li><b>Mobile No:</b>  This is needed to authenticate access to our application and to keep you updated with relevant information</li>

              <li><b>Email ID:</b> This is needed to authenticate access to our application and to keep you updated with relevant information. It is your username to access Nimeya web & mobile app and can’t be changed. </li>
              <li><b>Date of Birth:</b>  This provides your DOB as appeared in your PAN/Aadhar Card </li>
              <li><b>Date of Birth:</b>  This provides your DOB as appeared in your PAN/Aadhar Card </li>
              <li><b>Date of Birth:</b>  This provides your DOB as appeared in your PAN/Aadhar Card </li>
            </ul>
            </v-card-text>
           
          </v-card>
      </v-tab-item>
      <v-tab-item
        value="tab-8"
        v-if="tabName=='accountmanage'"
      >
        <AccountManagement flat v-if="tabName=='accountmanage'"/>

      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
  import Membership from './Membership.vue';
  import ReferFriends from './ReferFriends.vue';
  import RewardsPoint from './RewardsPoint.vue';
  import Myplan from '../Myplan/MyPlanList.vue';
  import NotificationSetting from './NotificationSetting.vue';
  import AccountManagement from '../account-management/AccountManagement.vue';
  import { Auth } from "aws-amplify";
  import { GET_PROFILE_DETAIL, GET_REFERRAL_DETAIL } from "../../store/actions.type";


  export default {
    components: {
      Membership,
      ReferFriends,
      RewardsPoint,
      Myplan,
      NotificationSetting,
      AccountManagement,
    },
    data () {
      return {
        tab: null,
        text: 'text1',
        tabName: 'member',
      }
    },
    created() {
      Fire.$on("picRefresh", () => {
        this.getPlanActive();
      });
    },
    mounted(){
      Fire.$emit("picRefresh");
    },
    methods:{
      CheckTab(tabName){
        this.tabName = tabName;
      },
      getPlanActive(){
        // if(this.$store.getters.getProfileDetail.data != undefined){
        //   alert(this.$store.getters.getProfileDetail.data.is_plan_active)
        //   this.$store.getters.getProfileDetail.data.is_plan_active == '1'? '' : this.$router.push({ name: "pricingPlan" }).catch(()=>{});
        // }
      },
    },
  }
</script>